export const notes = ["C","C#","D","D#","E","F","F#","G","G#","A","A#","B"];
export const getNoteClass = (note) => note.replace("#","sharp").toLowerCase();